<template>
    <div>
        <div class="a-group _with-suffix" v-if="curr">
            <input type="text" :tabindex="tabindex" :name="name + '_'" class="ang-form-control format-money text-right " :class="{'graterThanZero': graterThanZero}" :disabled="disabled" @keydown="keyDown($event)" @keyup="keyup($event)"
                   ref="input"
                   v-model="val" :placeholder="placeholder"
                   @input="updateValue($event.target)"
                    @click="setPosition($event.target)"
                   :required="required">
            <input type="hidden" :name="name" v-model="raw" :id="id"/>
            <div class="a-suffix" v-if="curr">{{curr}}</div>
        </div>
        <div v-else>
            <input type="text" :tabindex="tabindex" :name="name + '_'" class="ang-form-control format-money text-right " :class="{'graterThanZero': graterThanZero}" :disabled="disabled" @keydown="keyDown($event)" @keyup="keyup($event)"
                   ref="input"
                   v-model="val" :placeholder="placeholder"
                   @input="updateValue($event.target)"
                   @click="setPosition($event.target)"
                   :required="required" >
            <input type="hidden" :name="name" v-model="raw" :id="id"/>
        </div>

    </div>
</template>
<script>
import Inputmask from 'inputmask'
import $ from 'jquery'
export default{
  data () {
    return {
      raw: (this.value + '').replace(/\s+/g, '').replace(/,/g, '.').replace('PLN',''),
      val: typeof this.value === 'undefined' || this.value == 'undefined' ? '0' : this.value.replace(/\s+/g, '').replace('PLN','').replace('.', ','),
      required: !(this.notrequired)
    }
  },
  watch: {
    'value': function () {
      this.val = this.value
      this.raw = parseFloat((this.value + '').replace(/\s+/g, '').replace(/,/g, '.').replace('PLN','')).toFixed(2)
    }
  },
  props: ['name', 'value', 'id', 'placeholder', 'graterThanZero', 'curr', 'disabled', 'notrequired', 'tabindex'],
  methods: {
    keyDown: function (e) {
      if ([8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 188, 189, 110, 190, 37, 39, 109, 9].indexOf(e.which) === -1) { e.preventDefault() }
    },
    updateValue: function (target) {
      if (target.value.length === 0) { target.value = '0' }
      this.raw = (target.value + '').replace(/\s+/g, '').replace(/,/g, '.').replace('PLN','')
      if (this.raw.length === 0) { this.raw = 0 }
      this.$emit('input', target.value)
    },
    keyup: function (e) {
      if (e.target.value.length === 0) { e.target.value = '0' }
      if (e.which === 13) {
        this.$emit('enter', e.target)
      }
      this.$emit('keyup', e.target)
    },
    setPosition: function(target) {
      let disableCaretField = 4;
      let allPlaces = target.value.length;
      let disablePlace = allPlaces - disableCaretField
      let basicPosition = allPlaces - disableCaretField - 3

      if (target.selectionStart > disablePlace) {
          this.setCaretPosition(target, basicPosition);
      }

    },
    setCaretPosition: function (ctrl, pos) {
        // Modern browsers
        if (ctrl.setSelectionRange) {
            ctrl.focus();
            ctrl.setSelectionRange(pos, pos);

        // IE8 and below
        } else if (ctrl.createTextRange) {
            var range = ctrl.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    }
  },
  mounted () {
    Inputmask.extendAliases({
      pln: {
        suffix: ' PLN',
        prefix: '',
        groupSeparator: ' ',
        radixPoint: ',',
        alias: 'numeric',
        placeholder: '0',
        autoGroup: !0,
        digits: 2,
        digitsOptional: !1,
        // positionCaretOnClick: 'ignore',
        clearMaskOnLostFocus: !1
      }
    })
    Inputmask({
      'alias': 'pln',
      oncomplete: function (e) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('input', true, true)
        e.currentTarget.dispatchEvent(event)
        $(this).trigger('change')
      }
    }).mask('.format-money')
  }
}
</script>
